export default class BookingGuest {

  email_validation_url = "";
  emailField = $("#conversation_tenant_attributes_email");
  errorElement = $("#email_error");
  formButtons = document.querySelectorAll(".new-booking-form button");
  registerOptionsContainer = $("form .tenant .register_options");

  constructor(params) {
    this.email_validation_url = params.email_validation_url;
    this.emailField.blur((e) => {
      this.onBlur(e);
    })

    this.emailField.blur()
    this.enableLoginPopup();
  }

  enableLoginPopup() {
    $(".error-message").on('click', 'a.login', function(e) {
      e.preventDefault();
      $('.anonymous-conversation .sign-in a').click();
    })
  }

  onBlur(e) {
    if (e.currentTarget.value) {
      this.emailField.prop('disabled', true);
      this.validateEmail(e.currentTarget.value).then(response => {
        this.emailField.prop('disabled', false);
        if(response.errors != null) {
          this.errorElement.show();
          this.errorElement.html(response.errors.join(', '));
          this.registerOptionsContainer.hide();
          this.disableForm();
        } else {
          this.showNewAccountForm();
          this.errorElement.hide();
          this.enableForm();
        }
      })
    } else {
      this.showNewAccountForm();
      this.errorElement.hide();
      this.enableForm();
    }
  }


  disableForm() {
    [].forEach.call(this.formButtons, (elem) => {
      $(elem).hide();
    })
  }

  enableForm() {
    [].forEach.call(this.formButtons, (elem) => {
      $(elem).show();
    })
  }

  validateEmail(emailAddress) {
    return fetch(this.email_validation_url + "?email=" + encodeURIComponent(emailAddress), {
      method: "GET",
      credentials: 'same-origin'
    }).then(x => x.json());
  }

  showNewAccountForm() {
    this.emailField.prop('disabled', false);
    this.registerOptionsContainer.show();
    this.errorElement.hide();
  }
}
